const m = require('minthril/lib/hyperscript');
const createRender = require('minthril/lib/render');
const { App } = require('./components/app');

function mount(target, view) {
  const render = createRender(target.ownerDocument.defaultView);
  let nextDraw;

  function redraw() {
    if (nextDraw) return nextDraw;
    nextDraw = Promise.resolve().then(() => {
      render(target, view(redraw));
      nextDraw = null;
    });
    return nextDraw;
  }

  redraw();
}

function renderApp(target) { mount(target, redraw => m(App, { redraw })); }

if (!require.main) window.addEventListener('DOMContentLoaded', () => renderApp(window.document.body));

module.exports = renderApp;
